/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Hubs_Deals_Empty_DescriptionInputs */

const en_directory_hubs_deals_empty_description = /** @type {(inputs: Directory_Hubs_Deals_Empty_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Check back soon or launch your product to share an offer with the community.`)
};

const zh_directory_hubs_deals_empty_description = /** @type {(inputs: Directory_Hubs_Deals_Empty_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`稍后再来查看，或发布你的产品并向社区分享优惠。`)
};

/**
* | output |
* | --- |
* | "Check back soon or launch your product to share an offer with the community." |
*
* @param {Directory_Hubs_Deals_Empty_DescriptionInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_hubs_deals_empty_description = /** @type {((inputs?: Directory_Hubs_Deals_Empty_DescriptionInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Hubs_Deals_Empty_DescriptionInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_hubs_deals_empty_description(inputs)
	return zh_directory_hubs_deals_empty_description(inputs)
});
export { directory_hubs_deals_empty_description as "directory.hubs.deals.empty_description" }